module.exports = __webpack_public_path__ + "static/portfolio_gallery_1-50e27b458ce4941ffa562df023b3f58b.jpg";